export default __webpack_public_path__ + "static/media/statement.b147c386.png";